"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSSMY001 = void 0;
var DSSMY001_1 = require("./DSSMY001");
Object.defineProperty(exports, "DSSMY001", { enumerable: true, get: function () { return DSSMY001_1.DSSMY001; } });
